const testPageBody = document.querySelector('.test-page-body');
const faqPageBody = document.querySelector('.faq-page-body');
const resultsPageBody = document.querySelector('.results-body');
const finalPageBody = document.querySelector('.final-page-body');
const faqAllQuestionsDisplay = document.querySelectorAll('.faq-box__q-wrapper');

if (faqPageBody) {
  faqAllQuestionsDisplay.forEach((el) => {
    el.addEventListener('click', toggleAnswerDisplay);
  });

  function toggleAnswerDisplay() {
    this.nextElementSibling.classList.toggle('hide-element');
  }

  function hideAllAnswers() {
    document.querySelectorAll('.faq-box__answer-wrapper').forEach((el) => {
      el.classList.add('hide-element');
    });
  }

  hideAllAnswers();
} else if (testPageBody) {
  let currQuestionNum = 1;
  let currSectionNum = 1;
  let sectionDifficutly = '';
  const maxQuesNumInSection = 5;
  const maxSectionNum = 4;
  let isPaused = false;

  const spinnerContainerDisplay = document.querySelector('.spinner-container');
  const currQuestionDisplay = document.querySelector('.grid__item--curr-q');
  let currQuestionElem = document.querySelector('.question-img');
  const answersContainer = document.querySelector('.grid__item--answers-grid');
  const timerDisplay = document.querySelector('.timer-display');
  const qNumDisplay = document.querySelector('.q-num');
  const qInSectionDisplay = document.querySelector('.q-in-section');
  const sectionNumDisplay = document.querySelector('.section-num');
  const QMap = document.querySelector('.grid__item--all-q-grid');

  const pauseBtn = document.querySelector('.pause-btn');
  const backQuesBtn = document.querySelector('.back-btn');
  const nextQuesBtn = document.querySelector('.next-btn');
  const nextSectionBtn = document.querySelector('.next-section-btn');
  const finishBtn = document.querySelector('.finish-btn');

  const correctAnswersObj = {
    correctAnswersSec1: [3, 6, 1, 6, 2],
    correctAnswersSec2e: [3, 6, 1, 4, 5],
    correctAnswersSec2h: [3, 1, 5, 2, 6],
    correctAnswersSec3e: [5, 4, 4, 2, 1],
    correctAnswersSec3m: [5, 6, 2, 4, 3],
    correctAnswersSec3h: [5, 1, 6, 4, 2],
    correctAnswersSec4e: [5, 3, 1, 4, 1],
    correctAnswersSec4m: [4, 1, 2, 3, 2],
    correctAnswersSec4h: [4, 2, 1, 5, 6],
  };

  const user = {
    sec1Answers: [0, 0, 0, 0, 0],
    sec2Answers: [0, 0, 0, 0, 0],
    sec3Answers: [0, 0, 0, 0, 0],
    sec4Answers: [0, 0, 0, 0, 0],

    sec1Difficulty: '',
    sec2Difficulty: '',
    sec3Difficulty: '',
    sec4Difficulty: '',
  };

  let correctAnswersCnt = 0,
    timer;

  answersContainer.addEventListener('click', function (e) {
    e.preventDefault();

    if (e.target.closest('.answer') !== null) {
      let answerBox = e.target.closest('.answer');
      updateUserAnswers(answerBox);
      updateQMap();

      if (currQuestionNum !== maxQuesNumInSection) {
        currQuestionNum++;
      }
      renderNewQandA();
    }
  });
  nextQuesBtn.addEventListener('click', function (e) {
    e.preventDefault();

    currQuestionNum++;
    renderNewQandA();
  });
  backQuesBtn.addEventListener('click', function (e) {
    e.preventDefault();

    currQuestionNum--;
    renderNewQandA();
  });

  nextSectionBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const arr = user[`sec${currSectionNum}Answers`];
    arr.forEach(function (currAnswer, i) {
      if (
        currAnswer ===
        correctAnswersObj[
          `correctAnswersSec${currSectionNum}${sectionDifficutly}`
        ][i]
      ) {
        correctAnswersCnt++;
      }
    });

    sectionDifficutly = updateNextSectionDifficulty();
    currSectionNum++;
    currQuestionNum = 1;
    hideAllTestElements();
    renderSpinner();
    setTimeout(updateUIForNextSection, 3000);
  });

  finishBtn.addEventListener('click', function (e) {
    e.preventDefault();
    const arr = user[`sec${maxSectionNum}Answers`];
    arr.forEach(function (currAnswer, i) {
      if (
        currAnswer ===
        correctAnswersObj[
          `correctAnswersSec${maxSectionNum}${sectionDifficutly}`
        ][i]
      ) {
        correctAnswersCnt++;
      }
    });

    user.correctAnswersCnt = correctAnswersCnt;
    localStorage.setItem('user', JSON.stringify(user));
    if (correctAnswersCnt > 5) {
      window.location.assign('/results');
    } else {
      window.location.assign('/results-not-available');
    }
  });

  pauseBtn.addEventListener('click', handlePauseBtn);

  QMap.addEventListener('click', function (e) {
    e.preventDefault();
    if (e.target.classList.contains('map-item')) {
      currQuestionNum = Number(e.target.dataset.num);
      renderNewQandA();
    }
  });
  function updateNextSectionDifficulty() {
    let nextSecDiff;
    if (currSectionNum === 1) {
      if (correctAnswersCnt === 5) {
        nextSecDiff = 'h';
      } else nextSecDiff = 'e';
    } else if (currSectionNum === 2) {
      if (correctAnswersCnt < 8) {
        nextSecDiff = 'e';
      } else if (correctAnswersCnt < 10) {
        nextSecDiff = 'm';
      } else nextSecDiff = 'h';
    } else {
      if (correctAnswersCnt < 12) {
        nextSecDiff = 'e';
      } else if (correctAnswersCnt < 14) {
        nextSecDiff = 'm';
      } else nextSecDiff = 'h';
    }
    user[`sec${currSectionNum + 1}Difficulty`] = nextSecDiff;
    return nextSecDiff;
  }
  function updateQMap() {
    const currQmap = QMap.getElementsByClassName(`q${currQuestionNum}-link`)[0];
    currQmap.classList.add('mark-user-choice');
  }

  function clearQMap() {
    const AllMapDisplay = QMap.getElementsByClassName(`map-item`);

    for (let item of AllMapDisplay) {
      item.classList.remove('mark-user-choice');
    }
  }
  function updateUserAnswers(selectedAnswer) {
    user[`sec${currSectionNum}Answers`][currQuestionNum - 1] = Number(
      selectedAnswer.dataset.answerNum
    );
  }

  function renderNewQandA() {
    renderNewQuestion();
    renderNewAnswers();
    renderPrevNextBtns();
    renderNextSectionBtnIfNeeded();
    renderFinishBtnIfNeeded();
    qNumDisplay.textContent = currQuestionNum;
  }

  function renderNewQuestion() {
    currQuestionElem.setAttribute(
      'src',
      `../img/exam-images/sec${currSectionNum}${sectionDifficutly}/q${currQuestionNum}/q.png`
    );
  }

  function renderNewAnswers() {
    const allAnswers = document.querySelectorAll('.answer-img');
    allAnswers.forEach(function (el, i) {
      el.setAttribute(
        'src',
        `../img/exam-images/sec${currSectionNum}${sectionDifficutly}/q${currQuestionNum}/a${
          i + 1
        }.png`
      );
      el.closest('.answer').classList.remove('mark-user-choice');
    });
    const maybeAnswered =
      user[`sec${currSectionNum}Answers`][currQuestionNum - 1];

    if (maybeAnswered !== 0) {
      const userChoice = document.querySelector(`.answer${maybeAnswered}`);
      userChoice.closest('.answer').classList.add('mark-user-choice');
    }
  }

  function renderPrevNextBtns() {
    if (isFirstQInSection()) {
      backQuesBtn.classList.add('hide-element');
      nextQuesBtn.classList.remove('hide-element');
    } else if (isLastQInSection()) {
      nextQuesBtn.classList.add('hide-element');
      backQuesBtn.classList.remove('"hide-element');
    } else {
      backQuesBtn.classList.remove('hide-element');
      nextQuesBtn.classList.remove('hide-element');
    }
  }

  function renderNextSectionBtnIfNeeded() {
    const arr = user[`sec${currSectionNum}Answers`];
    if (arr.every((q) => q !== 0) && currSectionNum !== maxSectionNum) {
      renderNextSectionBtn();
    } else removeNextSectionBtn();
  }

  function renderFinishBtnIfNeeded() {
    const arr = user.sec4Answers;
    if (arr.every((q) => q !== 0)) {
      renderFinishBtn();
    } else removeFinishBtn();
  }

  function renderFinishBtn() {
    finishBtn.classList.remove('hide-element');
  }

  function removeFinishBtn() {
    finishBtn.classList.add('hide-element');
  }

  function renderNextSectionBtn() {
    nextSectionBtn.classList.remove('hide-element');
  }

  function removeNextSectionBtn() {
    nextSectionBtn.classList.add('hide-element');
  }

  function hideSection() {
    answersContainer.style.display = 'none';
    currQuestionDisplay.style.display = 'none';
    QMap.style.display = 'none';
    backQuesBtn.classList.add('hide-element');
    qNumDisplay.classList.add('hide-element');
    qInSectionDisplay.classList.add('hide-element');
    nextQuesBtn.classList.add('hide-element');
  }

  function showSection() {
    answersContainer.style.display = 'grid';
    currQuestionDisplay.style.display = 'block';
    QMap.style.display = 'grid';
    pauseBtn.classList.remove('hide-element');
    backQuesBtn.classList.remove('hide-element');
    qNumDisplay.classList.remove('hide-element');
    qInSectionDisplay.classList.remove('hide-element');
    nextQuesBtn.classList.remove('hide-element');
  }

  function updateUIForNextSection() {
    clearQMap();
    renderNewQandA();
    restartTimer();
    hideSpinner();
    renderAllTestElements();
    sectionNumDisplay.textContent = currSectionNum;
  }
  function isEndOfSection() {
    if (currQuestionNum > maxQuesNumInSection) {
      currQuestionNum = maxQuesNumInSection;
      return true;
    }
    return false;
  }
  function isFirstQInSection() {
    return (currQuestionNum - 1) % 5 === 0;
  }
  function isLastQInSection() {
    return currQuestionNum % 5 === 0;
  }
  function handlePauseBtn() {
    if (!isPaused) {
      hideSection();
      pauseBtn.innerHTML = `          <i class="fas fa-play-circle pause-icon"></i>
      CONTINUE`;
      removeNextSectionBtn();
      removeFinishBtn();
    } else {
      showSection();
      pauseBtn.innerHTML = `          <i class="fas fa-pause-circle pause-icon"></i>
      PAUSE`;
      renderNextSectionBtnIfNeeded();
      renderFinishBtnIfNeeded();
    }
    isPaused = !isPaused;
  }

  const startTimer = function () {
    let time = 1000;
    const tick = function () {
      if (!isPaused) {
        const minute = String(Math.trunc(time / 60)).padStart(2, 0);
        const second = String(time % 60).padStart(2, 0);
        timerDisplay.textContent = `${minute}:${second}`;
        if (time === 0) {
          clearInterval(timer);
          timerDisplay.textContent = `time's up!`;

          hideSection();
          finishBtn.classList.remove('hide-element');
          pauseBtn.classList.add('hide-element');
        }
        time--;
      }
    };

    tick();
    timer = setInterval(tick, 1000);
  };
  function restartTimer() {
    if (timer) clearInterval(timer);

    startTimer();
  }
  function hideAllTestElements() {
    answersContainer.style.display = 'none';
    currQuestionDisplay.style.display = 'none';
    QMap.style.display = 'none';
    backQuesBtn.classList.add('hide-element');
    qNumDisplay.classList.add('hide-element');
    qInSectionDisplay.classList.add('hide-element');
    nextQuesBtn.classList.add('hide-element');
    nextSectionBtn.classList.add('hide-element');
    pauseBtn.classList.add('hide-element');
    timerDisplay.classList.add('hide-element');
  }
  function renderAllTestElements() {
    answersContainer.style.display = 'grid';
    currQuestionDisplay.style.display = 'block';
    QMap.style.display = 'grid';
    pauseBtn.classList.remove('hide-element');
    qNumDisplay.classList.remove('hide-element');
    qInSectionDisplay.classList.remove('hide-element');
    nextQuesBtn.classList.remove('hide-element');
    pauseBtn.classList.remove('hide-element');
    timerDisplay.classList.remove('hide-element');
  }
  function renderSpinner() {
    spinnerContainerDisplay.classList.remove('hide-element');
  }
  function hideSpinner() {
    spinnerContainerDisplay.classList.add('hide-element');
  }
  function init() {
    hideSpinner();
    removeFinishBtn();
    removeNextSectionBtn();
    renderPrevNextBtns();
    qNumDisplay.textContent = currQuestionNum;
    startTimer();
  }
  init();
}

//--------------------Results Page--------------------
else if (resultsPageBody) {
  let user = JSON.parse(localStorage.getItem('user'));
  const userDetailsForm = document.querySelector('.user-details-form');
  userDetailsForm.addEventListener('submit', (e) => {
    e.preventDefault();
    user.age = document.getElementById('age').value;
    sendDataToServer().then((userId) =>
      window.location.assign(`/final/${userId}`)
    );
  });

  async function sendDataToServer() {
    let responseFromServer;
    try {
      let url = '/create-user';
      let options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify({
          user: user,
        }),
      };
      responseFromServer = await fetch(url, options).then((response) => {
        return response.json();
      });
    } catch (err) {
      console.log(`error!! - ${err}`);
    }

    user.userId = responseFromServer.userId;
    user.iqScore = responseFromServer.iqScore;
    localStorage.setItem('user', JSON.stringify(user));
    return responseFromServer.userId;
  }
} else if (finalPageBody) {
  const whatsappBtn = document.querySelector('.share-btn-whatsapp');
  const twitterBtn = document.querySelector('.share-btn-twitter');
  const facebookBtn = document.querySelector('.share-btn-facebook');
  const pageURL = 'https://www.brainalytics.org';
  const message =
    'I just finished the Brainalytics Free IQ test! Try it Yourelf!';
  const whatsappAPI = `https://wa.me/?text=${pageURL}. ${message}`;
  const twitterAPI = `https://twitter.com/intent/tweet?text=${pageURL}. ${message}`;
  const facebookAPI = `https://www.facebook.com/sharer/sharer.php?u=${pageURL}`;
  const applyExplanationBtnListener = () => {
    const allExplanationsBtns = document.querySelectorAll('.btn-explanation');
    allExplanationsBtns.forEach(function (el) {
      el.addEventListener('click', function () {
        el.nextElementSibling.classList.toggle('hide-element');
      });
    });
  };

  const init = () => applyExplanationBtnListener();
  whatsappBtn.addEventListener('click', () => {
    window.open(whatsappAPI, 'blank');
  });
  twitterBtn.addEventListener('click', () => {
    window.open(twitterAPI, 'blank');
  });
  facebookBtn.addEventListener('click', () => {
    window.open(facebookAPI, 'blank');
  });
  init();
}
